import {useEffect, useState} from "react";
import baseUrl from "../../../baseUrl";
import {requester} from "../../../services/requester";

const LABELS = {
    settlements: 'землища (общо в базата)',
    active_settlements: 'активни землища',
    companies: 'ползватели (фирми)',
    users: 'потребители на системата',
    initial_info: 'записи изходни данни',
    deals_rows: 'редове замени (4 на замяна)',
    drawings: 'изчертавания',
    audit_log: 'записи в журнала',
};

export const AdminSystem = () => {
    const request = requester();
    const [info, setInfo] = useState(null);
    const [error, setError] = useState('');

    useEffect(() => {
        request.get(`${baseUrl()}/admin/system/info`)
            .then(setInfo)
            .catch(err => setError(err.message || 'Грешка при зареждане.'));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div>
            <h3 className="mb-3">Система</h3>

            {error && <div className="alert alert-danger">{error}</div>}

            <div className="row g-4">
                <div className="col-md-6">
                    <div className="card">
                        <div className="card-header">Основна информация</div>
                        <div className="card-body">
                            {!info ? <span className="text-muted">Зареждане…</span> : (
                                <>
                                    <table className="table table-sm mb-2">
                                        <tbody>
                                        {Object.entries(info.counts).map(([k, v]) => (
                                            <tr key={k}>
                                                <td>{LABELS[k] || k}</td>
                                                <td className="text-end fw-bold">{v.toLocaleString('bg-BG')}</td>
                                            </tr>
                                        ))}
                                        </tbody>
                                    </table>
                                    <div className="text-muted small">Версия на системата: {info.version}</div>
                                </>
                            )}
                        </div>
                    </div>
                </div>

                <div className="col-md-6">
                    <div className="card">
                        <div className="card-header">Резервни копия</div>
                        <div className="card-body">
                            <p className="text-muted mb-0">
                                Автоматично нощно резервно копие на базата (03:00, пази 14 дни)
                                — настроено на ниво сървър. Сваляне на копие от този панел —
                                предстои. Справките не оставят файлове на диска; протоколите
                                при замяна се пазят постоянно.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
